import { Component, OnDestroy, OnInit } from "@angular/core"
import { Subscription } from "rxjs"
import { GRADE_BANDS } from "../../models/constants"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"

@Component({
    selector: "app-disciplines",
    templateUrl: "./disciplines.component.html",
    styleUrls: ["./disciplines.component.scss"],
    standalone: false,
})
export class DisciplinesComponent implements OnInit, OnDestroy {
    chNodes: CHNode[]
    disciplineRows: CHNode[][] = []
    GRADE_BANDS = GRADE_BANDS
    private subscriptions: Subscription[] = []
    private readonly ROW_SIZES = [4, 3]

    constructor(private browsingService: BrowsingService) {}

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.tree.subscribe(
                (chNodes: CHNode[]) => {
                    this.chNodes = chNodes
                    this.disciplineRows = this.buildDisciplineRows(chNodes)
                },
                (error) => console.error(`[CUSTOM Error]${error}`)
            )
        )
    }

    private buildDisciplineRows(chNodes: CHNode[]): CHNode[][] {
        if (!chNodes?.length) return []
        const rows: CHNode[][] = []
        let index = 0
        for (const size of this.ROW_SIZES) {
            if (index >= chNodes.length) break
            rows.push(chNodes.slice(index, index + size))
            index += size
        }
        if (index < chNodes.length) {
            rows.push(chNodes.slice(index))
        }
        return rows
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
